(function () {
    'use strict';
    
    angular.module('PWAPoCApp').factory('schemaService', schemaService);

    schemaService.$inject = [
        '$q',
        '$http',
        'cacheService',
        'toasterService',
        'translateService',
        '$rootScope',
        'updateQueue',
    ];

    function schemaService($q, $http, cacheService, toasterService, translateService, $rootScope, updateQueue) {
        const cachePrefix = '_schemas_';
        const schemaCacheKey = cachePrefix + 'sludgeSchema';
        const surveyTypesCachePrefix = cachePrefix + "surveyTypes";

        let service = {
            getSchemaByTypeId,
            getSurveyTypes,
            saveSurvey,
            saveSurveyRequest,
        };

        return service;


        function getSchemaByTypeId(typeId) {
            let deferred = $q.defer();
            const cacheKey = schemaCacheKey + "_" + typeId;
            cacheService
                .has(cacheKey)
                .then((exists) => {
                    if (exists) {
                        return cacheService.get(cacheKey);
                    } else {
                        return getSchemaServer(typeId);
                    }
                })
                .then((schema) => deferred.resolve(schema))
                .catch(deferred.reject);

            return deferred.promise;
        }

         function getSchemaServer(typeId) {
            let deferred = $q.defer(),
                schema = null;
            
            const cacheKey = schemaCacheKey + '_' + typeId;

            $http.get('api/surveys/byTypeId/' + typeId)
                .then(response => {
                    schema = response.data;
                    return cacheService.set(cacheKey, schema);
                })
                .then(() => deferred.resolve(schema))
                .catch(deferred.reject);

            return deferred.promise;
        }

        function getSurveyTypes() {
            const deferred = $q.defer();

            cacheService.get(surveyTypesCachePrefix).then((cachedSurveyTypes) => {
                if (cachedSurveyTypes) {
                    deferred.resolve(cachedSurveyTypes)
                } else {
                    $http
                        .get("api/surveys/types")
                        .then(function (response) {
                            let surveyTypes = response.data;
        
                            cacheService.set(
                                surveyTypesCachePrefix,
                                surveyTypes
                            );
                            return surveyTypes;
                        })
                        .then(function (surveyTypes) {
                            deferred.resolve(surveyTypes);
                        })
                        .catch(function () {
                            deferred.reject();
                        });
                }
            });

            return deferred.promise;
        }

        function saveSurvey(savedSurvey) {
            const deferred = $q.defer();

            if ($rootScope.isOnline) {
                $http.post("api/surveys/save", savedSurvey)
                    .then(resp => {
                        const saved = resp.data;
                        toasterService.success(translateService.translate('general.surveySavedSuccess'));
                        deferred.resolve(saved);
                    })
                    .catch(err => {
                        toasterService.error(translateService.translate('general.surveySavedFail'));
                        deferred.reject(err);
                    });
            } else {
                const updateAction = {
                    id: Date.now(),
                    type: 'saveSurvey',
                    parameters: [savedSurvey],
                    retryCount: 3,
                    isPostponable: true
                };

                updateQueue.addUpdateAction(updateAction)
                    .then(() => {
                        toasterService.info(translateService.translate('general.surveySavedLater'));
                        deferred.resolve();
                    })
                    .catch(() => {
                        toasterService.error(translateService.translate('general.surveySavedQueueFail'));
                        deferred.reject();
                    });
            }

            return deferred.promise;
        }

        function saveSurveyRequest(savedSurvey) {
            const deferred = $q.defer();

            $http.post("api/surveys/save", savedSurvey)
                .then(resp => {
                    const saved = resp.data;
                    toasterService.success(translateService.translate('general.surveySavedSuccess'));
                    deferred.resolve(saved);
                })
                .catch(err => {
                    toasterService.error(translateService.translate('general.surveySavedFail'));
                    deferred.reject(err);
                });

            return deferred.promise;
        }
    }

})();